import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import ProducerCastingNewPage from '../../Producer/Castings/ProducerCastingNewPage';

/**
 * 어드민이 특정 대행 제작사 소유로 공고를 등록하는 화면.
 * 폼은 제작사가 쓰는 것과 완전히 동일한 컴포넌트를 재사용한다 —
 * 별도 축약 폼을 만들면 필수값이 어긋나 서버 검증에서 걸린다.
 */
export default function AdminManagedCastingPage() {
  const { producerProfileId } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const companyName = params.get('company') ?? '';

  const profileId = Number(producerProfileId);

  if (!Number.isFinite(profileId) || profileId <= 0) {
    return (
      <AdminLayout pageId="managed-producers">
        <div className="ag-card">
          <div style={{ fontSize: 13, color: 'var(--color-danger)' }}>
            <i className="ti ti-alert-triangle" /> 제작사 정보가 없어 공고를 만들 수 없습니다.
          </div>
          <button
            className="ag-btn ag-btn--sm"
            style={{ marginTop: 12 }}
            onClick={() => navigate('/admin/managed-producers')}
          >
            대행 계정 목록으로
          </button>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout pageId="managed-producers">
      <div className="admin-topbar">
        <h1>대행 공고 등록</h1>
        <div className="admin-topbar__right">
          <span style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>
            {companyName ? `${companyName} 소유로 등록됩니다` : `제작사 #${profileId} 소유로 등록됩니다`}
          </span>
          <span className="admin-badge"><i className="ti ti-user" /> admin</span>
        </div>
      </div>

      <ProducerCastingNewPage
        adminProducerProfileId={profileId}
        doneRedirect="/admin/managed-producers"
      />
    </AdminLayout>
  );
}
